// extracted by mini-css-extract-plugin
export default {"popover":"TextInputPopover_popover__GkSg4","extraButton":"TextInputPopover_extraButton__XamRS"};